export default __webpack_public_path__ + "static/media/download.b19ae3e5.svg";